exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".keyboard{\n    width:100%;\n    /*height: 230px;*/\n    /*background-color: #555;*/\n    text-align: center;\n  }\n  .keyboard td{\n    border: 4px solid #e9e9e9;\n    padding: 0px;\n    margin: 0px;\n  }\n  .keyboard td button{\n    border: 0px;\n    margin: 0px;\n    border: 0px;\n    background-color: #555;\n    color: #FFF;\n    font-size: 20px;\n    width: 100%;\n    padding-top: 12px;\n    padding-bottom: 12px;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/controls/numeric-keyboard/numeric-keyboard.component.css
// module id = ../../../../../src/app/controls/numeric-keyboard/numeric-keyboard.component.css
// module chunks = main